import React from 'react';
import PropTypes from 'prop-types';
import {getWidgetValues} from "sportinglife-react-common/widgets";
import OutLink from "../../../Common/components/OutLink";
import Image from "../../../Common/components/Image";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const ImageWidget = ({widget, media}) => {
  if (!widget || !media) {
    return (
      <div className="news-article-body-image">
        <div className="news-article-image">
        </div>
      </div>
    );
  }

  const {media_id, external, href, caption} = getWidgetValues(widget, ["media_id", "external", "href", "caption"]);
  const imageSet = media[media_id];

  if (!imageSet) {
    return null;
  }

  return (
    <div className="news-article-body-image">
      <div className="news-article-image">
      <span>
        {href ? <OutLink to={href} isExternal={external == "true"}>
            <Image imageMedia={imageSet} imageType="articlePage"/>
          </OutLink>
          :
          <Image imageMedia={imageSet} imageType="articlePage"/>
        }
      </span>
      </div>
      {caption && caption.trim() && <div className="photo-caption">{caption}</div>}
    </div>
  );
};

ImageWidget.mapProps = (props) => ({
  media: props.media,
  widget:  props.widget
})
ImageWidget.propTypes = {
  media: PropTypes.object,
  widget: PropTypes.object
}

export default withErrorBoundary(ImageWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/Image.widget.js